exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".singleSelector__radioGroup___QGV5u {\n  width: 100%;\n  align-self: center; }\n  @media (max-width: 768px) {\n    .singleSelector__radioGroup___QGV5u {\n      margin-bottom: 15px; } }\n\n.singleSelector__radioBtnWrapper___1WZBM {\n  height: 60px;\n  display: flex;\n  align-items: center; }\n  .singleSelector__radioBtnWrapper___1WZBM > label {\n    white-space: normal;\n    display: flex !important;\n    align-items: center; }\n\n.singleSelector__rentPriceTypeRadioGroup___2pbUT {\n  width: 60%;\n  margin-top: 20px; }\n  @media (max-width: 768px) {\n    .singleSelector__rentPriceTypeRadioGroup___2pbUT {\n      margin-top: 0;\n      width: 100%; } }\n", ""]);

// exports
exports.locals = {
	"radioGroup": "singleSelector__radioGroup___QGV5u",
	"radioBtnWrapper": "singleSelector__radioBtnWrapper___1WZBM",
	"rentPriceTypeRadioGroup": "singleSelector__rentPriceTypeRadioGroup___2pbUT"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/FormControls/SingleSelector/singleSelector.scss
// module id = 2142
// module chunks = 6